<script setup lang="ts">
import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useFilesStore } from '@/stores/files'
import { useJobsStore } from '@/stores/jobs'
import { useUsageStore } from '@/stores/usage'
import { useBridgeStore } from '@/stores/bridge'
import { useCatalogStore } from '@/stores/catalog'
import { useAddressStore } from '@/stores/addresses'
import { useNotificationsStore } from '@/stores/notifications'
import { useWatermarksStore } from '@/stores/watermarks'
import { useMaterialsStore } from '@/stores/materials'
import { usePaymentStore } from '@/stores/payment'

const auth = useAuthStore()
const files = useFilesStore()
const jobs = useJobsStore()
const usage = useUsageStore()
const bridge = useBridgeStore()
const catalog = useCatalogStore()
const addresses = useAddressStore()
const notifications = useNotificationsStore()
const watermarks = useWatermarksStore()
const materials = useMaterialsStore()
const payment = usePaymentStore()

const { isAuthenticated } = storeToRefs(auth)

watch(
  isAuthenticated,
  (signedIn, was) => {
    if (signedIn) {
      files.watch()
      return
    }

    files.unwatch()
    if (!was) return

    files.resetSession()
    jobs.$reset()
    usage.$reset()
    bridge.$reset()
    catalog.$reset()
    watermarks.$reset()
    materials.$reset()
    addresses.$reset()
    notifications.$reset()
    payment.$reset()
  },
  { immediate: true },
)
</script>

<template>
  <RouterView />
</template>
